import { render, staticRenderFns } from "./Faq.vue?vue&type=template&id=a2fc1cf4&scoped=true&"
import script from "./Faq.vue?vue&type=script&lang=js&"
export * from "./Faq.vue?vue&type=script&lang=js&"
import style0 from "./Faq.vue?vue&type=style&index=0&id=a2fc1cf4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2fc1cf4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/induline.salamander.live/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a2fc1cf4')) {
      api.createRecord('a2fc1cf4', component.options)
    } else {
      api.reload('a2fc1cf4', component.options)
    }
    module.hot.accept("./Faq.vue?vue&type=template&id=a2fc1cf4&scoped=true&", function () {
      api.rerender('a2fc1cf4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/ui/Faq.vue"
export default component.exports